<template>
  <div class="border-t border-element-neutral py-7.5" :class="{ grid: variant === 'default' }">
    <div class="pr-16">
      <h2 class="pb-2.5" :class="{ 'pb-5': variant === 'singleColumn' }">
        <slot name="title">
          {{ title }}
        </slot>
        <span v-if="variant === 'singleColumn'" class="text-neutral text-body-regular ml-5">{{ description }}</span>
      </h2>
      <p v-if="(description ?? $slots.description) && variant === 'default'" class="text-neutral">
        <slot name="description">
          {{ description }}
        </slot>
      </p>
    </div>
    <div>
      <slot />
    </div>
  </div>
</template>

<script lang="ts" setup>
interface Props {
  title?: string;
  description?: string;
  variant?: 'default' | 'singleColumn';
}

withDefaults(defineProps<Props>(), {
  variant: 'default',
});
</script>

<style lang="scss" scoped>
.grid {
  grid-template-columns: 1fr 2fr;
}
</style>
